// extracted by mini-css-extract-plugin
export default {"live":"_1MtD6KLKltjUspaGviaEq7","withParentTitle":"_2MHzLJBYqfX4dev7R5tSMW"};